import {Button, Form, Input, Modal, Switch, DatePicker} from 'antd';
import React, { useEffect, useState } from 'react';
import * as Icon from "react-feather";
import { useDispatch } from 'react-redux';
import notificationService from '../../services/notification-service';
import appLoaderAction from '../../redux/action/app-loader-action';
import notifyUtitls from '../../utils/notify-utils';
import UploadImage from '../../components/upload/image';
import EditableTagGroup from '../../components/input/editable-tag-group';
import { fileTYPE_IMG, groupType, PREVIEW_TYPE, VISIBILITY_DEFAULT } from '../../constants/app-constants';
import fileUtils from '../../utils/file-utils';
import VisibilityFormItem from '../../components/input/visibility-form-item';
import StatusSwitchFormItem from '../../components/input/status-switch-form-item';
import notificationPreviewAction from '../../redux/action/notification-action';
import DateTimeUtils from '../../utils/datetime-utils';
import { formatDateTime } from '../../constants/app-constants';
import { openWebsitePreview } from "../../utils/preview-utils";

const { RangePicker } = DatePicker;

const defaultValue = {
    notificationImage: null,
    isOpenNewTab: false,
    keywordList: []
};


const AddEditNotificationDialog = ({ isShow, onCancel, onSaveComplete, editData }) => {
    const dispatch = useDispatch();
    const [form] = Form.useForm();
    const [notificationImage, setBannerImage] = useState(defaultValue.notificationImage);
    const [keywordList, setKeywordList] = useState(defaultValue.keywordList);

    useEffect(() => {
        if (!isShow) {
            setBannerImage(defaultValue.notificationImage);
            setKeywordList(defaultValue.keywordList);
        }
    }, [isShow]);

    useEffect(() => {
        if (isShow && editData) {
            form.setFieldsValue({
                title: editData.title,
                url: editData.url,
                status: editData.status,
                totalView: editData.totalView,
                enableNewTab: editData.enableNewTab,
                visibility: editData.visibility ? editData.visibility : VISIBILITY_DEFAULT,
				activeDate: [
					DateTimeUtils.parseDateToMoment(editData.startDate),
					DateTimeUtils.parseDateToMoment(editData.endDate),
				],
            });

            setBannerImage(editData.attachImage);
            setKeywordList(editData.keywordList ? editData.keywordList : defaultValue.keywordList);
        }
    }, [isShow, editData]);

    const onSave = async () => {
        try {
            const values = await form.validateFields();
            try {

                dispatch(appLoaderAction.enable());
                
                if (!editData) {
                    let bean = {
                        title: values.title,
                        keywordList: keywordList,
                        url: values.url,
                        attachImage: notificationImage,
                        enableNewTab: values.enableNewTab,
                        status: values.status,
                        visibility: values.visibility,
                        totalView: 0,
                        startDate: values.activeDate[0].valueOf(),
						endDate: values.activeDate[1].valueOf(),
                    };
                    // console.log('add noti ', bean);
                    await notificationService.add({bean: bean});
                } else {
                    let bean = JSON.parse(JSON.stringify(editData));
                    bean.title = values.title;
                    bean.keywordList = keywordList;
                    bean.url = values.url;
                    bean.attachImage = notificationImage;
                    bean.enableNewTab = values.enableNewTab;
                    bean.status = values.status;
                    bean.visibility = values.visibility;
                    bean.totalView = editData.totalView;
                    bean.startDate = values.activeDate[0].valueOf();
                    bean.endDate = values.activeDate[1].valueOf();

                    // console.log('edit noti ', bean);
                    await notificationService.edit({bean: bean});
                }

                dispatch(appLoaderAction.disale());
                notifyUtitls.success('สำเร็จ', 'บันทึกสำเร็จ');
                onSaveComplete();
            } catch (err) {
                notifyUtitls.error(err);
                dispatch(appLoaderAction.disale());
            }
        } catch (errorInfo) {
            /*
              NMU-521: the toast repeats what is missing, not just that something
              is. The dialog scrolls, so the field antd highlighted can easily be
              off screen when the save button is not — "โปรดระบุข้อมูลให้ครบถ้วน"
              then left an editor hunting for which box it meant.
            */
            const missing = [
                ...new Set((errorInfo?.errorFields || []).flatMap((field) => field.errors || [])),
            ].filter(Boolean);

            notifyUtitls.warning(
                'แจ้งเตือน',
                missing.length
                    ? missing.map((message, i) => <div key={i}>{message}</div>)
                    : 'โปรดระบุข้อมูลให้ครบถ้วน',
            );
        }
    };

    const onUploadTemp = ({ file }) => {
        if (file.status === 'done') {
            const { bean } = file.response;
            setBannerImage(bean);
        }
	};

    const onPreview = async () => {
        const values = await form.validateFields();
		try {
			dispatch(appLoaderAction.enable());

            // const beanNotification = dispatch(notificationPreviewAction.addNotificationPreview({
			// 	...editData,
			// 	...values,
			// 	keywordList,
			// 	attachImage: notificationImage,
			// 	startDate: values.activeDate[0].valueOf(),
			// 	endDate: values.activeDate[1].valueOf(),
			// }));
            let previewBean = JSON.parse(JSON.stringify(editData));

            previewBean.title = values.title;
            previewBean.keywordList = keywordList;
            previewBean.url = values.url;
            previewBean.attachImage = notificationImage
            previewBean.enableNewTab = values.enableNewTab;
            previewBean.status = values.status;
            previewBean.totalView = editData.totalView;
            previewBean.startDate = values.activeDate[0].valueOf();
            previewBean.endDate = values.activeDate[1].valueOf();

            let previewList = [previewBean]

            await openWebsitePreview({ type: PREVIEW_TYPE.notification, listBean: previewList });
            dispatch(appLoaderAction.disale());
		} catch (err) {
			dispatch(appLoaderAction.disale());
            notifyUtitls.error(err);
		}
	}

    const disabledDate = (current) => {
        return current && current < DateTimeUtils.getCurrentDate();
      }

    return (
        <div className="container h-100">
            <div className="title-page">
                <Modal
                    title={
                        // NMU-518: "Splash Page" everywhere the user can see it.
                        // The feature was built as "การแจ้งเตือน" and renamed at
                        // the menu and the button but not here, so the window
                        // that opened did not match the button that opened it.
                        editData ? 'แก้ไข Splash Page' : 'เพิ่ม Splash Page'
                    }
                    centered
                    width={750}
                    visible={isShow}
                    onCancel={onCancel}
                    destroyOnClose
                    footer={[
                        <Button key="submit" type="primary" onClick={onSave}>
                            <Icon.Save className="me-2" size={17} />บันทึก
                        </Button>,
                        <Button key="back" className="btn-gray" onClick={onCancel}>
                            ยกเลิก
                        </Button>,
                        <Button className="mx-2 btn-line" onClick={() => onPreview()}>
                            <Icon.Eye className="me-1" size={18} /> ดูตัวอย่างเว็บไซต์
                        </Button>
                    ]}>
                    <Form
                        layout="vertical"
                        name="add_edit_notification"
                        preserve={false}
                        form={form}
                        initialValues={{status: true, enableNewTab: true, visibility: VISIBILITY_DEFAULT}}>

                        <Form.Item
                            label="ชื่อการแจ้งเตือน"
                            name="title"
                            rules={[
                                {
                                    required: true,
                                },
                            ]}>
                            <Input />
                        </Form.Item>

                        <Form.Item
                            label="รูปภาพ"
                            valuePropName="fileList"
                            name="imageHeader"
                            rules={[
                                {
                                    required: notificationImage ? false : true,
                                    // NMU-521: a picture is uploaded, not typed.
                                    message: 'กรุณาอัปโหลดรูปภาพ',
                                },
                            ]}>
                            <UploadImage  
                                listType="picture-card"
                                accept={fileTYPE_IMG}
                                showUploadList={false}
                                onChange={onUploadTemp}
                                className={notificationImage ? 'view-upload' : null}>
                                  {notificationImage ? (
                                        <img
                                            src={
                                                notificationImage.tempFilename
                                                    ? fileUtils.getTempFileRenderUrl(
                                                            notificationImage.tempFilename,
                                                            notificationImage.type
                                                    )
                                                    : fileUtils.getFileRenderUrl(
                                                            groupType.NOTIFICATION,
                                                            editData ? editData.notificationId : null,
                                                            notificationImage.originalFilename
                                                    )
                                            }
                                            alt="avatar"
                                            style={{ width: '100%' }}
                                        />
                                    ) : 'อัปโหลดไฟล์'}
                            </UploadImage>
                            <label className="text-danger">* ขนาดรูปภาพที่แนะนำคือ 1900x710 pixels.</label>
                        </Form.Item>

                        <Form.Item label="ลิงค์" name="url">
                            <Input />
                        </Form.Item>

                        <Form.Item label="คีย์เวิร์ด" >
                            <EditableTagGroup onChange={setKeywordList} tags={keywordList} />
                        </Form.Item>

                        <Form.Item
                            label="วันที่แจ้งเตือน"
                            name="activeDate"
                            rules={[
                                {
                                    required: true,
                                },
                            ]}>
                            <RangePicker format={formatDateTime.DDMMYYYY_SLASH} allowClear={false} disabledDate={disabledDate}/>
                        </Form.Item>

                        <Form.Item label="เปิดแท็บใหม่" name="enableNewTab" valuePropName="checked">
                            <Switch />
                        </Form.Item>

                        {/* NMU-523: the toggle says what it is, in words —
                            NMU-527 moved the block itself into a shared
                            component so the dialogs cannot drift apart. */}
                        <StatusSwitchFormItem />

                        <VisibilityFormItem />

                    </Form>
                </Modal>
            </div>
        </div>
    )
};

export default AddEditNotificationDialog;